"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var connectionTestEpic_1 = require("./connectionTestEpic");
var metaEpic_1 = require("./metaEpic");
var eventResultsEpic_1 = require("./eventResultsEpic");
var eventSummaryEpic_1 = require("./eventSummaryEpic");
var individualResultsEpic_1 = require("./individualResultsEpic");
var mediaEpic_1 = require("./mediaEpic");
var rootEpic = redux_observable_1.combineEpics(connectionTestEpic_1.testConnectionEpic, metaEpic_1.getMetaData, eventResultsEpic_1.startEventResultsPolling, eventResultsEpic_1.stopEventResultsPolling, eventSummaryEpic_1.getEventSummaryEpic, individualResultsEpic_1.startIndividualResultsPolling, individualResultsEpic_1.stopIndividualResultsPolling, mediaEpic_1.startMediaPolling, mediaEpic_1.stopMediaPolling);
exports.default = rootEpic;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/index.js
 ** module id = 2075
 ** module chunks = 0
 **/